module.exports = __webpack_public_path__ + "img/sang.5b4ae7c2.png";